import { createRoute } from '@tanstack/react-router';
import { PobockaForm } from '@/modules/pujcovna/PobockaForm';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/pujcovna/sprava/pobocky/nova',
  component: PobockaForm,
});
